import { Link } from "react-router-dom";
import { DataKeys } from "../../types";
import { useLang } from "../Context";
import { SpacingFrame } from "../display/Frame";
import { HealthSection } from "./HealthSection";
import { getLocalized, HealthLang } from "./healthTypes";
import {
    HEALTH_CTA_BAND_BG,
    healthCtaBand,
    healthCtaButton,
    healthCtaSecondaryButton,
    healthCtaSubtitle,
    healthCtaTitle,
    healthFocusVisible,
} from "./healthVisualStyles";

interface HealthPrimaryCtaProps {
    data: DataKeys;
}

function localePath(path: string, lang: HealthLang): string {
    if (lang === "Zh" && path.startsWith("/")) return `/tw${path}`;
    if (lang === "Jp" && path.startsWith("/")) return `/jp${path}`;
    return path;
}

export function HealthPrimaryCta({ data }: HealthPrimaryCtaProps) {
    const { lang } = useLang();
    const hLang = lang as HealthLang;
    const title = getLocalized(data?.title, hLang);
    const subtitle = getLocalized(data?.subtitle, hLang);
    const ctaLabel = getLocalized(data?.ctaLabel, hLang);
    const href = localePath(data?.href ?? "/contact-us", hLang);
    const secondaryLabel = getLocalized(data?.secondaryLabel, hLang);
    const secondaryHref = localePath(data?.secondaryHref ?? "/contact-us", hLang);

    return (
        <HealthSection id="cta-primary" compact style={{ backgroundColor: HEALTH_CTA_BAND_BG }}>
            <div className={healthCtaBand}>
                <SpacingFrame spacing={32} center>
                    <div className="flex w-full min-w-0 flex-col gap-2 text-left lg:items-center lg:text-center">
                        <h2 className={healthCtaTitle}>{title}</h2>
                        <p className={healthCtaSubtitle}>{subtitle}</p>
                    </div>
                    <div className="flex w-full flex-col gap-3 lg:w-auto lg:flex-row lg:justify-center">
                        <Link to={href} className={`${healthCtaButton} ${healthFocusVisible}`}>
                            {ctaLabel}
                        </Link>
                        {secondaryLabel && (
                            <Link
                                to={secondaryHref}
                                className={`${healthCtaSecondaryButton} ${healthFocusVisible}`}
                            >
                                {secondaryLabel}
                            </Link>
                        )}
                    </div>
                </SpacingFrame>
            </div>
        </HealthSection>
    );
}
